import React, { useEffect } from "react";
import Swal from "sweetalert2";
import axios from "axios";

const AddTransportModal = ({ isAddOpen, onAddClose, formData, setFormData, fetchData, user, branch }) => {
  // 🔹 Fetch new Transport No when modal opens
  useEffect(() => {
    const fetchTransportNo = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/transport_addNo`);
        if (response.data.transportNo) {
          setFormData((prevState) => ({
            ...prevState,
            code: response.data.transportNo,
            user: user,
            branch: branch,
          }));
        }
      } catch (error) {
        console.error("Error fetching Number:", error);
      }
    };

    if (isAddOpen) {
      fetchTransportNo();
    }
  }, [isAddOpen, setFormData, user, branch]);

  if (!isAddOpen) return null;

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || formData.name.trim() === "") {
      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: "Transport Name should not be empty.",
      });
      return;
    }

    try {
      Swal.fire({
        title: "Submitting...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await axios.post(`https://rfs2.infraconsoft.net.in/api/transport_insert`, {
        code: formData.code,
        name: formData.name,
        user: user,
        branch: branch,
      });

      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Inserted!",
          text: "Transport inserted successfully.",
        });

        // ✅ Reset form after save
        setFormData({
          code: "",
          name: "",
          user: user,
          branch: branch,
        });

        onAddClose();
        fetchData();
      }
    } catch (error) {
      console.error("Error inserting transport:", error);

      if (error.response?.data?.message) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.response.data.message,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Insert failed. Please try again.",
        });
      }
    }
  };

  return (
    <div className="modal">
      <div className="modal-content" style={{ position: "relative" }}>
        <div style={{ position: "absolute", top: "10px", right: "10px" }}>
          <button className="close-btn" onClick={onAddClose} style={{ position: "initial" }}>
            &times;
          </button>
        </div>
        <h3>Add New Transport</h3>
        <form className="vehicle-form" onSubmit={handleEditSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>Transport Code :</label>
              <input type="text" name="code" value={formData.code} onChange={handleEditChange} readOnly />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Transport Name :</label>
              <input type="text" name="name" value={formData.name} onChange={handleEditChange} />
            </div>
          </div>

          <div className="btn-cls">
            <button type="submit" className="submit-btn">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddTransportModal;
